import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
        alignContent: 'center',
        borderColor: 'black',
        borderWidth: 1,
    },
    invoiceContainer: {
        width: '100%',
        justifyContent: 'flex-start',
        marginTop: '10px',
        flexDirection: 'row',
        borderColor: 'black',
        color: 'black',
        border: 1,
        height: 150,
        textAlign: 'Left',
        fontStyle: 'bold',
        marginBottom: '10px'
    },
    invoice: {
        width: '50%',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        borderColor: 'black',
        color: 'black',
        border: 1,
        textAlign: 'Left',
        fontStyle: 'bold',
    },
    invoiceHeader: {
        backgroundColor: '#3778C2',
        textAlign: 'center',
        height: 20,
        color: '#fff',
        alignItems: 'center',
        marginBottom: 10,
        paddingTop: 2
    },
    item: {
        textAlign: 'left',
        paddingLeft: 8,
    },
    header: {
        width: '100%',
        flexGrow: 1,
        textAlign: 'center',
    },

});

const InvoiceTableFooter = ({ items }) => {
    return (
        <Fragment>
            <View style={styles.invoiceContainer}>
                <View style={styles.invoice}>
                    <View style={styles.invoiceHeader}>
                        <Text style={styles.header}>Bank Details</Text>
                    </View>
                    <Text style={styles.item}>Name: {items.agentRegistration.accountHolderName}</Text>
                    <Text style={styles.item}>Account Number: {items.agentRegistration.accountNumber}</Text>
                    <Text style={styles.item}>Bank Name: {items.agentRegistration.bankName}</Text>
                    <Text style={styles.item}>Branch Name: {items.agentRegistration.branchName}</Text>
                    <Text style={styles.item}>IFSC Code: {items.agentRegistration.ifscCode}</Text>
                    <Text style={styles.item}>E & O.E: </Text>
                </View>
                <View style={styles.invoice}>
                    <View style={styles.invoiceHeader}>
                        <Text style={styles.header}>Signature</Text>
                    </View>
                    <Text style={styles.item}>"Certified that the particulars given above are true and correct"</Text>
                    <Text style={styles.item}></Text>
                    <Text style={styles.item}>For {items.agentRegistration.agentName}</Text>
                    <Text style={styles.item}> </Text>
                    <Text style={styles.item}> </Text>
                    <Text style={styles.item}>"Authorised Signatory"</Text>
                </View>
            </View>
        </Fragment>
    )
};

export default InvoiceTableFooter;